module.exports = __webpack_public_path__ + "static/img/0004.cba9bd74.png";